import React from 'react';

const ProgTableroBita2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*0.95
  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/02613b07-9499-4ca4-8b74-3475c70421fd/page/sIgGD" 
      frameborder="0" style="border:0" 
      allowfullscreen 
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox">
      </iframe>
    </div>
  )
}

export default ProgTableroBita2